import React, { useMemo } from "react";
import Input from "../../component/input/Input";
import useFormPermission from "../useFormPermission";

const PermissionableInput = ({ roles = ["admin"], ...props }) => {
  const hasFormPermission = useFormPermission(roles);
  const disabled = useMemo(
    () => !hasFormPermission(props.source),
    [hasFormPermission, props.source]
  );
  return <Input {...props} disabled={disabled} />;
};
export default PermissionableInput;
